import {Component, inject, Input} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
    selector: 'app-print-essay-feedback',
    templateUrl: './print-essay-feedback.component.html',
    styleUrls: ['./print-essay-feedback.component.scss']
})
export class PrintEssayFeedbackComponent {

    @Input() convertedText = '';
    @Input() studentAnswer: any;
    @Input() previousFeedBack: any[] = [];
    @Input() selectedPreviousStudentAnswer: any;
    @Input() totalAns: any[] = [];
    @Input() totalFeedbackMaxHeight: any;
    @Input() selectedFeedBackIndex: any;
    @Input() feedbackList: any[] = [];
    @Input() totalFeedBack: any;
    @Input() chartOptions: any;
    @Input() scorePercentage = 0;
    @Input() totalIndivialScore = 0;
    @Input() totalScore = 0;
    @Input() score = 0;
    @Input() contentType = '';
    @Input() contentName = '';
    @Input() studentLogin = false;
    private sanitizer = inject(DomSanitizer);
    private chartInstance: any;
    stars = Array(5).fill(0);

    convertMarkdownToHtml(markdown: string, breakTagType = 'double'): SafeHtml {
        markdown = markdown.replace(/^'+|'+$/g, '');
        let html = markdown.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
        html = html.replace(/\\n/g, '<br>').replace(/\n/g, '<br>');
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    getValue(value: string): string {
        if (!value) return '';
        const parts = value.split('_');
        const formatted = parts.map(part => part.charAt(0).toUpperCase() + part.slice(1)).join(' ');
        return formatted;
    }

    onChartInit(event: any) {
        // Save reference to the ApexCharts instance
        this.chartInstance = event;
    }

    ngOnInit() {
        console.log(this.totalFeedBack, 'totalFeedBack');
        console.log(this.chartOptions, 'chartOption');
    }

    ngOnDestroy(): void {
        console.log('destoryCalled');
        // Safely destroy the chart when component is destroyed
        if (this.chartInstance) {
            try {
                this.chartInstance.destroy();
            } catch (e) {
                console.warn('Chart cleanup failed or already destroyed:', e);
            }
            this.chartInstance = null;
        }
    }

}
